import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to, from) => {
  // Only run on server-side
  if (typeof window === 'undefined') {
    const nuxtApp = useNuxtApp()
    const event = nuxtApp.ssrContext?.event

    if (event?.req?.headers) {
      const headers = event.req.headers
      
      // CRITICAL: Only collect non-React Native headers for persistence
      // We NEVER want to persist x-go-client to avoid false detection in client-side
      const debugHeaders: Record<string, string> = {}
      
      // Process all x-go-* headers EXCEPT x-go-client
      Object.keys(headers).forEach(key => {
        const lcKey = key.toLowerCase()
        // Only store headers that start with x-go- and are NOT x-go-client
        if (lcKey.startsWith('x-go-') && lcKey !== 'x-go-client') {
          debugHeaders[lcKey] = headers[key] as string
        }
      })
      
      // Create a flag for debug mode
      const hasDebugMode = !!headers['x-go-debugmode'] && headers['x-go-debugmode'] === 'true'
      
      // If we have any debug headers OR debug mode is enabled, set cookies
      if (Object.keys(debugHeaders).length > 0 || hasDebugMode) {
        // Only store the JSON of non-React Native headers
        const headersCookie = JSON.stringify(debugHeaders)
        
        if (event.res?.setHeader) {
          // Set cookies but NEVER include x-go-client
          event.res.setHeader('Set-Cookie', [
            `go-debug-headers=${encodeURIComponent(headersCookie)}; path=/;`,
            `go-debug-mode=${hasDebugMode ? 'true' : 'false'}; path=/;`,
          ])
          console.log('Debug middleware: Headers set in cookies (excluding React Native detection)')
        }
      }
    }
  }
})
